/**
 * Словник: pl.
 * Згенеровано tool/gen_web_locales.py з lib/l10n/app_pl.arb — руками не правити.
 *
 * ⚠️ Новий рядок: спершу в ARB усіх мов, потім ключ у en.ts і перегенерація.
 * Паритет ключів перевіряється на збірці (npm run check:i18n).
 */
export default {
  waiting: "⏳ Oczekiwanie na drugiego uczestnika...",
  connectionLost: "Utracono połączenie",
  peerLeft: "👋 Drugi uczestnik opuścił rozmowę",
  connectionError: "🚫 Błąd połączenia",
  connectionFailedTryAgain: "🚫 Nie udało się połączyć z serwerem. Spróbuj ponownie.",
  reconnectionFailed: "🚫 Utracono połączenie. Nie udało się go przywrócić po {attempts} próbach.",
  connectionErrorWithDetails: "🚫 Błąd połączenia: {error}",
  speakerLoud: "Głośno",
  speakerEar: "Słuchawka",
  copyRoomId: "Kopiuj ID pokoju",
  share: "Udostępnij",
  linkCopied: "🔗 Link skopiowany!",
  idCopied: "🆔 ID skopiowane!",
  startMeeting: "Rozpocznij spotkanie",
  chooseAction: "Wybierz działanie",
  createNewRoom: "Nowy pokój",
  scheduleCall: "Zaplanuj rozmowę",
  calendarOpened: "📅 Otwarto kalendarz",
  linkCopiedToClipboard: "🔗 Link skopiowany do schowka",
  enterRoomId: "Wpisz ID pokoju",
  roomIdValidationError: "ID pokoju może zawierać tylko litery, cyfry i myślniki",
  joinRoom: "DOŁĄCZ",
  termsAndPrivacyHelp: "Regulamin i prywatność | Pomoc",
  invite: "Zaproś",
  mySettings: "Moje ustawienia",
  peerSettings: "Ustawienia rozmówcy",
  blockRemoteControl: "Blokuj zdalne sterowanie",
  iAgreeToTerms: "Akceptuję regulamin usługi",
  termsOfUse: "Warunki korzystania",
  privacyPolicy: "Polityka prywatności",
  howToUse: "Jak korzystać",
  termsAcceptanceRequired: "Aby korzystać z usługi, musisz zaakceptować regulamin",
  ok: "OK",
  permissionsRequired: "Wymagane uprawnienia",
  permissionsNeededMessage: "Do prawidłowego działania aplikacja potrzebuje następujących uprawnień:",
  permissionsNote: "Uwaga: po zmianie uprawnień w Ustawieniach system iOS uruchomi aplikację ponownie. To normalne.",
  permissionsEnableMessage: "Aby kontynuować, włącz te uprawnienia w ustawieniach urządzenia.",
  cancel: "Anuluj",
  openSettings: "Otwórz ustawienia",
  websocketError: "Błąd WebSocket",
  roomFull: "Pokój jest pełny",
  timeExpired: "Czas minął",
  remaining: "pozost.",
  mediaPermissionsRequired: "Rozmowy wideo wymagają dostępu do kamery i mikrofonu. Przyznaj uprawnienia w przeglądarce.",
  mediaPermissionsRequiredMobile: "Rozmowy wideo wymagają dostępu do kamery i mikrofonu. Przyznaj uprawnienia w ustawieniach aplikacji.",
  browserSettings: "Ustawienia przeglądarki",
  openAppSettings: "Otwórz ustawienia",
  grantPermissions: "Przyznaj uprawnienia",
  permissionsNotGranted: "Nie przyznano uprawnień. Przyznaj je, aby kontynuować.",
  permissionRequestError: "Błąd podczas żądania uprawnień: {error}",
  camera: "Kamera",
  microphone: "Mikrofon",
  cameraDescription: "Do przesyłania obrazu",
  microphoneDescription: "Do przesyłania dźwięku",
  continueWithoutPermissions: "Kontynuuj bez uprawnień",
  mediaPermissionsRequiredFallback: "Rozmowy wideo wymagają uprawnień do multimediów. Przyznaj je w ustawieniach przeglądarki.",
  mediaPermissionsRequiredMobileFallback: "Rozmowy wideo wymagają uprawnień do multimediów. Przyznaj je w ustawieniach aplikacji.",
  browserSettingsFallback: "Ustawienia przeglądarki",
  openAppSettingsFallback: "Otwórz ustawienia",
  permissionsPermanentlyDenied: "Uprawnienia zostały trwale odrzucone. Włącz je w ustawieniach aplikacji.",
  continueText: "Kontynuuj",
  mirror: "Lustro",
  fitContain: "Dopasuj",
  fitCover: "Wypełnij",
  switchCamera: "Przełącz",
  block: "Blokuj",
  pip: "PiP",
  mic: "Mikrofon",
  video: "Wideo",
  speaker: "Głośnik",
  readyToConnect: "Zaczynamy rozmowę?",
  startOneOnOne: "Rozpocznij rozmowę wideo",
  createPrivateLink: "Link gotowy w sekundę",
  welcomeExplainer: "Utwórz link i wyślij go, komu chcesz. Otworzy się nawet bez aplikacji.",
  joinHaveLink: "Masz link?",
  joinFieldHint: "Wklej link lub ID",
  roomInputInvalid: "Wklej link do rozmowy lub ID pokoju (litery, cyfry i myślniki)",
  guestTitle: "Masz zaproszenie na rozmowę wideo",
  guestBody: "Pokój jest gotowy. Rozmówca zobaczy cię, gdy tylko dołączysz.",
  guestJoin: "Dołącz",
  guestFreeNote: "Dołączanie jest zawsze bezpłatne",
  guestCreateOwn: "Utwórz własny pokój",
  guestInvalidTitle: "Ten link wygląda na uszkodzony",
  guestInvalidBody: "Poproś o link jeszcze raz albo utwórz własny pokój.",
  inviteCardTitle: "Twój pokój jest gotowy",
  inviteCardBody: "Wyślij link osobie, z którą chcesz porozmawiać",
  inviteShareLink: "Udostępnij link",
  inviteCopy: "Kopiuj",
  inviteBrowserHint: "Otwiera się w każdej przeglądarce. Nie trzeba instalować aplikacji.",
  inviteSentHint: "Wysłane? Rozmówca pojawi się tutaj, gdy tylko otworzy link.",
  inviteShareMessage: "Dołącz do mojej rozmowy wideo w One2One 👋\nPo prostu otwórz link. Działa w przeglądarce, nie musisz nic instalować:\n{link}",
  copyLink: "Kopiuj link",
  consentBannerText: "Czy możemy zbierać statystyki użytkowania? Pokazują nam, z których funkcji korzystają użytkownicy. Treść rozmów nigdy do nich nie trafia.",
  consentAllow: "Zezwól",
  consentDeny: "Nie zezwalaj",
  privacySettingsLink: "Ustawienia statystyk",
} as const;
